module.exports = __webpack_public_path__ + "9aebee36cd6e0abd2f8ee2c92132c078.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/face/index/images/banner-bg11.png
// module id = 329
// module chunks = 3